import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  TextField,
  Typography,
  Stack
} from "@mui/material"
import LoadingButton from "@mui/lab/LoadingButton"
import SaveIcon from "@mui/icons-material/Save"
import CloseIcon from "@mui/icons-material/Close"
import Alerts from "../../errorHandeling/Alerts"
import Helpers from "../../utils/Helpers"
import UserRoleDropdown from "../../components/userRoleDropdown/UserRoleDropdown"
import OrgsDropdown from "../../../toms/components/orgsDropdown/OrgsDropdown"

const UserAccountModal = (props) => {
  return (
    <Dialog
      open={props.open}
      maxWidth="true"
      fullWidth={true}
      PaperProps={{
        style: { borderRadius: "10px", width: "912px", margin: 0 },
      }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          bgcolor: "#116c6f",
          color: "white",
          position: "fixed",
          borderTopRightRadius: "10px",
          borderTopLeftRadius: "10px",
          width: "912px",
          zIndex: 1000,
        }}
      >
        <Typography variant="h5" component="div" style={{ flexGrow: 1 }}>
          {props.title}
        </Typography>
        <IconButton
          aria-label="cancel"
          sx={{ color: "#fff" }}
          onClick={props.handleClearData}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <form onSubmit={props.handleSave}>
        <DialogContent
          dividers
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            marginTop: 7,
          }}
        >
          <div>
            <br/>
            <Alerts
              iserror={props.iserror}
              errorMessages={props.errorMessages}
              isSuccess={props.isSuccess}
              successMessages={props.successMessages}
              iserrorShow={props.iserrorShow}
            />
          </div>
          <Box display="flex" justifyContent="center" alignItems="center">
            <Stack
              spacing={3} // Adjust this value as needed for spacing between elements
              width="100%"
            >
              <Stack direction="row" spacing={2}>
                <OrgsDropdown
                  orgCode={props.orgCode ? props.orgCode : ""}
                  onChange={props.handleOnChange}
                />
                <UserRoleDropdown
                  selectRole={
                    props.values.userRole ? props.values.userRole : ""
                  }
                  handleOnChange={props.handleOnChange}
                />
              </Stack>

              <Stack direction="row" spacing={2}>
                <TextField
                  fullWidth
                  disabled={props.userNameDisabled}
                  id="inputUserName"
                  variant="outlined"
                  name="username"
                  label="User Name"
                  value={props.values.username ? props.values.username : ""}
                  required
                  onChange={props.handleOnChange}
                />
                <TextField
                  fullWidth
                  id="inputFirstName"
                  variant="outlined"
                  name="firstName"
                  label="First Name"
                  value={props.values.firstName ? props.values.firstName : ""}
                  required
                  onChange={props.handleOnChange}
                />
              </Stack>

              <Stack direction="row" spacing={2}>
                <TextField
                  required
                  fullWidth
                  id="inputLastName"
                  variant="outlined"
                  name="lastName"
                  label="Last Name"
                  value={props.values.lastName ? props.values.lastName : ""}
                  onChange={props.handleOnChange}
                />
                {props.visibility === "block" && (
                  <>
                    <TextField
                      fullWidth
                      variant="outlined"
                      name="password"
                      label="Password"
                      type="password"
                      value={props.values.password ? props.values.password : ""}
                      required
                      onChange={props.handleOnChange}
                      error={props.passwordMatches}
                      helperText={props.errors.cofmPassword}
                    />
                    <TextField
                      fullWidth
                      variant="outlined"
                      name="cofmPassword"
                      label="Confirm Password"
                      type="password"
                      value={
                        props.values.cofmPassword
                          ? props.values.cofmPassword
                          : ""
                      }
                      required
                      onChange={props.handleOnChange}
                      error={props.passwordMatches}
                      helperText={props.errors.cofmPassword}
                    />
                  </>
                )}
              </Stack>

              <Stack direction="row" spacing={2}>
                <TextField
                  fullWidth
                  id="inputDisplayName"
                  variant="outlined"
                  name="displayName"
                  label="Display Name"
                  value={
                    props.values.displayName ? props.values.displayName : ""
                  }
                  onChange={props.handleOnChange}
                />
                <TextField
                  fullWidth
                  id="inputReferenceNo"
                  variant="outlined"
                  name="referenceNo"
                  label="Reference No"
                  value={
                    props.values.referenceNo ? props.values.referenceNo : ""
                  }
                  onChange={props.handleOnChange}
                />
              </Stack>

              <Stack direction="row" spacing={2}>
                <TextField
                  fullWidth
                  id="inputPrimEmail"
                  variant="outlined"
                  type="email"
                  name="primEmail"
                  label="Primary Email Address"
                  value={props.values.primEmail ? props.values.primEmail : ""}
                  onChange={props.handleOnChange}
                />
                <TextField
                  fullWidth
                  id="inputSecEmail"
                  variant="outlined"
                  type="email"
                  name="secEmail"
                  label="Secondary Email Address"
                  value={props.values.secEmail ? props.values.secEmail : ""}
                  onChange={props.handleOnChange}
                />
              </Stack>

              <Stack direction="row" spacing={2}>
                <TextField
                  fullWidth
                  placeholder="Enter Contact 07X XXX XXXX"
                  id="inputPrimContact"
                  variant="outlined"
                  type="number"
                  name="primContact"
                  label="Primary Contact"
                  value={
                    props.values.primContact ? props.values.primContact : ""
                  }
                  onChange={props.handleOnChange}
                  error={props.isPrimContactValid}
                  helperText={props.errors.primContact}
                />
                <TextField
                  fullWidth
                  placeholder="Enter Contact 07X XXX XXXX"
                  id="inputSecContact"
                  variant="outlined"
                  type="number"
                  name="secContact"
                  label="Secondary Contact"
                  value={props.values.secContact ? props.values.secContact : ""}
                  onChange={props.handleOnChange}
                  error={props.isSecContactValid}
                  helperText={props.errors.secContact}
                />
              </Stack>

              <Stack direction="row" spacing={2}>
                <TextField
                  fullWidth
                  id="inputPrimAddress"
                  variant="outlined"
                  name="primAddress"
                  label="Primary Address"
                  value={
                    props.values.primAddress ? props.values.primAddress : ""
                  }
                  onChange={props.handleOnChange}
                />
                <TextField
                  fullWidth
                  id="inputSecAddress"
                  variant="outlined"
                  name="secAddress"
                  label="Secondary Address"
                  value={props.values.secAddress ? props.values.secAddress : ""}
                  onChange={props.handleOnChange}
                />
              </Stack>
            </Stack>
          </Box>
        </DialogContent>
        <DialogActions sx={{ p: "1.25rem" }}>
          <Button
            onClick={props.handleClearData}
            variant="outlined"
            color="error"
          >
            Cancel
          </Button>
          <LoadingButton
            type="submit"
            color="success"
            loading={props.isSubmit}
            variant="contained"
            loadingPosition="start"
            startIcon={<SaveIcon />}
          >
            {Helpers.applyRemoverWords(props.title, "User Account")}
          </LoadingButton>
        </DialogActions>
      </form>
    </Dialog>
  )
}

export default UserAccountModal
